import axios from 'axios'
import apiFetch from '@wordpress/api-fetch';

import {
    NetworkInfo,
    NetworkSite,
    WPSearchResultItem,
    WPSingleJobItem,
} from "../typings";

/**
 * Get the network sites from the custom API endpoint created as part of the plugin.
 * Network sites queries the API in the same environment as the plugin is running, so used apiFetch
 */
export const getNetworkSites = async (): Promise<Array<NetworkSite>> => {
    return await apiFetch<Promise<Array<NetworkSite>>>({path: '/wp-json/cg/seo/network/sites'});
}

/**
 * ==== Network site search for search term ====
 *
 * Connects to the default WordPress search endpoint to search for a post based
 * on the inputValue param. The base url for the WordPress end-point need to passed as
 * the baseUrl param
 * @param inputValue The search query
 * @param baseUrl The base url to connect to. Example: https://www.example.com/ or https://www.example.com/fr-fr/
 * @returns WPSearchResultItem[]
 */

interface Window {
  cg_jobs_jobstream_url?: string;
}

const jobUrl = (window as Window).cg_jobs_jobstream_url;

// Define the base URL for the API
const BASE_URL = jobUrl ? jobUrl : 'https://cg-job-search-microservices.azurewebsites.net/api';

// Define the type for the function parameters
interface SearchParams {
    search?: string; // Search keyword
    page?: number; // Page number for pagination
    size?: number; // Number of items per page
    filters?: Record<string, any>; // The filter parameters as a key-value object
    country_code?: string;
}

interface SearchPostType {
    count: number,
    data: WPSearchResultItem[]
}

// Define the function to fetch job listings for similar Jobs
export const searchPosts = async (params: SearchParams): Promise<SearchPostType> => {
    try {
      // Manually construct the query string
      const queryParams = new URLSearchParams();
  
      if (params.filters) {
        for (const [key, value] of Object.entries(params.filters)) {

         if(key !== 'country_code' && value){
            if (Array.isArray(value)) {
                queryParams.append(key, value.join(","));
            } else {
                queryParams.append(key, value);
            }
         }   
        }
      }
  
      if (params.page) {
        queryParams.append('page', params.page.toString());
      }
  
      if (params.size) {
        queryParams.append('size', params.size.toString());
      }
  
      if (params.search) {
        queryParams.append('search', params.search);
      }

      if (params.country_code) {
        queryParams.append('country_code', params.country_code);
      }
  
      // Send a GET request to the API with manually constructed query parameters
      const response = await axios.get<SearchPostType>(`${BASE_URL}/job-search`, {
        params: queryParams
      });
  
      // Return the data received from the API
      return response.data;
    } catch (error) {
      console.error('Error fetching job listings:', error);
      throw error; // Rethrow error to be handled by the calling code
    }
  };

  export const singlePost = async (jobId: string): Promise<WPSingleJobItem> => {   
    const res = await axios.get(`${BASE_URL}/job-details/${jobId}`);
    return res.data.data;
} 